export const PLATFORM_THEME_PREFERENCES = ["light", "dark"] as const;

export type PlatformThemePreference =
  (typeof PLATFORM_THEME_PREFERENCES)[number];

export const DEFAULT_PLATFORM_THEME_PREFERENCE: PlatformThemePreference =
  "light";
export const PLATFORM_THEME_COOKIE_NAME = "babel.platform.theme";
export const PLATFORM_THEME_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
export const PLATFORM_THEME_SHARED_COOKIE_DOMAIN = "withkaleo.com";
export const PLATFORM_THEME_SHARED_COOKIE_HOSTS = [
  "app.withkaleo.com",
  "docs.withkaleo.com",
] as const;
export const LEGACY_DASHBOARD_THEME_COOKIE_NAME =
  "babel.dashboard.theme-preference";

const PLATFORM_THEME_PREFERENCE_SET = new Set<string>(
  PLATFORM_THEME_PREFERENCES,
);
const PLATFORM_THEME_SHARED_COOKIE_HOST_SET = new Set<string>(
  PLATFORM_THEME_SHARED_COOKIE_HOSTS,
);

type BrowserLocation = {
  hostname?: string;
  protocol?: string;
};

export function isPlatformThemePreference(
  value: unknown,
): value is PlatformThemePreference {
  return (
    typeof value === "string" && PLATFORM_THEME_PREFERENCE_SET.has(value)
  );
}

export function serializePlatformThemePreferenceCookie(
  preference: PlatformThemePreference,
  location: BrowserLocation = {},
): string {
  const hostname = (location.hostname ?? "").trim().toLowerCase();
  const isHttps = location.protocol === "https:";
  const usesSharedProductionDomain =
    isHttps && PLATFORM_THEME_SHARED_COOKIE_HOST_SET.has(hostname);
  const attributes = [
    `${PLATFORM_THEME_COOKIE_NAME}=${preference}`,
    `Max-Age=${PLATFORM_THEME_COOKIE_MAX_AGE_SECONDS}`,
    "Path=/",
    "SameSite=Lax",
  ];

  if (usesSharedProductionDomain) {
    attributes.push(`Domain=${PLATFORM_THEME_SHARED_COOKIE_DOMAIN}`);
  }
  if (isHttps) {
    attributes.push("Secure");
  }

  return attributes.join("; ");
}
